import React from 'react';
import StructuredData from 'react-google-structured-data';

type TFlags = {
  isMultiMake: boolean;
  isNoMake: boolean;
  isSingleModel: boolean;
  isAllModels: boolean;
  hasCvnaid: boolean;
};
interface IContentReviewsStructuredData {
  hasReviews?: boolean;
  reviewMake: string;
  flags: TFlags;
  reviewModel: string;
  overallAverage: string;
  overallCount: string;
  highestRating: string;
  lowestRating: string;
}
const ContentReviewsStructuredData = ({
  hasReviews,
  flags,
  reviewMake,
  reviewModel,
  overallAverage,
  overallCount,
  highestRating,
  lowestRating
}: IContentReviewsStructuredData) => {
  const isOneMake = !flags.isMultiMake && !flags.isNoMake;
  const isOneModel = isOneMake && flags.isSingleModel && !flags.isAllModels;
  const reviewVehicleName = isOneModel
    ? `${reviewMake} ${reviewModel}`
    : reviewMake;

  const reviewsStructuredData = {
    '@context': 'http://schema.org',
    '@type': 'Review',
    itemReviewed: {
      '@type': 'Car',
      name: reviewVehicleName,
      brand: reviewMake,
      model: isOneModel ? reviewModel : '',
      vehicleModelDate: ''
    },
    reviewRating: {
      '@type': 'AggregateRating',
      ratingValue: parseFloat(overallAverage).toFixed(2),
      ratingCount: overallCount,
      worstRating: parseFloat(lowestRating).toFixed(2),
      bestRating: parseFloat(highestRating).toFixed(2)
    },
    author: {
      '@type': 'Organization',
      name: 'Carvana'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Carvana'
    }
  };

  const shouldRenderStructuredData =
    !flags.hasCvnaid && isOneMake && hasReviews;

  return shouldRenderStructuredData ? (
    <StructuredData data={reviewsStructuredData} />
  ) : null;
};

export default ContentReviewsStructuredData;
